var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "notice-wrap"
  }, [_c('div', {
    staticClass: "notice",
    class: {
      mb: _vm.mb
    }
  }, [_vm._v("\n            " + _vm._s(_vm.txt) + "\n    ")])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };